export const WeCityOrganizationIdHeader = 'wecity-organization-id';

const Global = {};
export default Global;
